import ChineseTWMessage from './ChineseTWMessage';

const translates = {
    "zh-TW": ChineseTWMessage,
};

export default translates;